import { useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';

import {
  readForecastFiltersFromSearchParams,
  writeForecastFiltersToSearchParams,
  type ForecastFilters,
} from '@/features/forecasts/utils/forecastFilters';

export function useForecastQueryState() {
  const [searchParams, setSearchParams] = useSearchParams();
  const state: ForecastFilters = useMemo(() => readForecastFiltersFromSearchParams(searchParams), [searchParams]);
  const query = searchParams.get('query') ?? '';

  function setState(nextState: ForecastFilters) {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        writeForecastFiltersToSearchParams(next, nextState);
        return next;
      },
      { replace: true },
    );
  }

  function setSearch(nextQ: string) {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        const trimmed = nextQ.trim();
        if (trimmed) next.set('query', trimmed);
        else next.delete('query');
        return next;
      },
      { replace: true },
    );
  }

  return {
    searchParams,
    state,
    setState,
    clearState: () => setState({}),
    query,
    setSearch,
  };
}
